<template>
    <div class="house-filter" :class="{ open: openState}">
        <div class="house-filter-wrap" v-bind:style="{'height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default">
                <div v-if="isAllGroup" class="title level1-title-font">業務分群</div>
                <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.groupCode">
                    <ul>
                        <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                            {{item.groupName}}
                        </li>
                    </ul>
                </rent-select>
                <div class="title level1-title-font">業務</div>
                <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.agentCid || isGroupChange">
                    <ul>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default house-type">
                <div class="title level1-title-font">完善房源</div>
                <rent-select refName="complete" :selectMsg="filter.complete==null?'所有狀態':filter.complete=='1'?'完善':'未完善'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filter.complete==null" :isEdit="filter.complete!=null">
                    <ul>
                        <li data-id="1">
                            完善
                        </li>
                        <li data-id="0">
                            未完善
                        </li>

                    </ul>
                </rent-select>
            </div>
            <div class="default house-type">
                <div class="title level1-title-font">上架狀態</div>
                <rent-select refName="publish" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filter.publish==null">
                    <ul>
                        <li data-id="1">
                            上架
                        </li>
                        <li data-id="0">
                            下架
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.city">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.district || isCityChange">
                        <ul v-if="filter.city">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">租金</div>
                <vue-slider v-model="amount" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="default house-type">
                <div class="title level1-title-font">出租類型</div>
                <rent-select refName="houseType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.houseType">
                    <ul>
                        <li data-id="FAMILY_HOME">
                            整層住家
                        </li>
                        <li data-id="STUDIO">
                            套房
                        </li>
                        <li data-id="ROOM">
                            雅房
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default buildin-type">
                <div class="title level1-title-font">房屋類型</div>
                <rent-select refName="buildingType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.buildingType">
                    <ul>
                        <li data-id="APARTMENT">
                            公寓
                        </li>
                        <li data-id="HIGH_RISE">
                            電梯大樓
                        </li>
                        <li data-id="TOWN_HOUSE">
                            透天
                        </li>
                        <li data-id="VILLA">
                            別墅
                        </li>
                    </ul>
                </rent-select>
            </div>
            <!-- <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterResultTotal}}
                </div>
            </div> -->
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            openState: this.isOpen,
            filter: {
                groupCode: null,
                agentCid: null,
                complete: null,
                publish: null,
                city: null,
                district: null,
                fromRent: null,
                toRent: null,
                buildingType: null,
                houseType: null,
                page: 1
            },
            amount: [0, 100000],
            isDefault: false,
            filterState: 0,
            address: {
                county: {
                    state: false,
                    msg: '所有縣市'
                },
                district: {
                    state: false,
                    msg: '所有區域'
                },
                road: {
                    state: false,
                    msg: '所有路段'
                }
            },
            filterResultTotal: 0,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
            isGroupChange: false,
            isCityChange: false
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        // this.getHashForResultTotal()
        // if( this.$route.query.complete == 'noCompleted' ){
        //     this.$store.dispatch('setBizHouseMgtFilterQuery', {completed: 'noCompleted'})
        // }
        // window.addEventListener('scroll', this.handleScroll);

    },
    // destroyed () {
    //     console.log('123')
    //     this.$store.dispatch('setBizHouseMgtFilterDefault')
    // },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        filter: {
            handler: function (val) {
                this.$store.dispatch('setBizHouseMgtFilterQuery', val)
                  .then(()=>{
                    this.$store.dispatch('getBizHouseMgtListV2')
                  })
            },
            deep: true
        },
        amount: {
          handler: function (val) {
            if(val.length){
              this.filter.fromRent = val[0] <= 0 ? null : val[0];
              this.filter.toRent = val[1] >= 100000 ? null : val[1];
              if(this.filter.fromRent || this.filter.toRent)
                this.filterState = 1;
            }
          },
          deep: true
        },
        // filterTotal: {
        //     handler: function () {
        //         this.getHashForResultTotal()
        //     },
        //     deep: true
        // },
        $route:{
            handler: function (val) {
                console.log(val)
                // this.getHashForResultTotal()
                if(val.query.complete){
                    this.filter.complete = val.query.complete
                    this.filterState = 1
                    this.$router.replace({name: 'bizHouseMgtDefault'})
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        setFilterDefault: function () {
            this.filter = {
                groupCode: null,
                agentCid: null,
                complete: null,
                publish: null,
                city: null,
                countyId: null,
                district: null,
                fromRent: null,
                toRent: null,
                buildingType: null,
                houseType: null,
                page: 1
            },
            this.amount = [0, 100000],
            this.filterState = 0
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        // getHashForResultTotal: function () {
        //     let hashTag = decodeURIComponent(this.$route.hash)
        //
        //     if( hashTag == '#全部' ){
        //         this.filterResultTotal = this.filterTotal.all
        //     }else if( hashTag == '#已租' ){
        //         this.filterResultTotal = this.filterTotal.rented
        //     }else if( hashTag == '#未租' ){
        //         this.filterResultTotal = this.filterTotal.rent
        //     }else{
        //         this.filterResultTotal = this.filterTotal.all
        //     }
        // },
        getSelectId: function (value) {
            this.filterState = 1
            if( value.ref == 'orgGroup' ){
                this.filter.groupCode = value.id
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.agentCid = null
            }else if( value.ref == 'member' ){
                this.filter.agentCid = value.id
                this.isGroupChange = false
            }else if( value.ref == 'county' ){
                this.isCityChange = true
                this.address.district.state = true
                this.filter.district = null
                this.filter.city = value.name
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.isCityChange = false
                this.address.district.state = false
                this.filter.district = value.name
            }else if( value.ref == 'buildingType' ){
                this.filter.buildingType = value.id
            }else if( value.ref == 'houseType' ){
                this.filter.houseType = value.id
            }else if(value.ref == 'complete'){
                this.filter.complete = value.id ? value.id == 1 : null;
            }else if(value.ref == 'publish'){
                this.filter.publish = value.id ? value.id == 1 : null;
            }
            this.filter.page = 1;
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
    },
    computed: {
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            // filterTotal: 'GET_BIZ_HOUSE_MGT_FILTER_RESULT_TOTAL',
            // filterCountyIsEmpty: 'GET_BIZ_HOUSE_MGT_FILTER_COUNTY_IS_EMPTY',
            // filterDistrictIsEmpty: 'GET_BIZ_HOUSE_MGT_FILTER_DISTRICT_IS_EMPTY',
            // filterHouseTypeIsEmpty: 'GET_BIZ_HOUSE_MGT_HOUSE_TYPE_IS_EMPTY',
            // filterBuildingTypeIsEmpty: 'GET_BIZ_HOUSE_MGT_BUILDING_TYPE_IS_EMPTY',
            // filterCompletedIsEmpty: 'GET_BIZ_HOUSE_MGT_COMPLETED_EMPTY',
            // filterPublishIsEmpty: 'GET_BIZ_HOUSE_MGT_PUBLISH_EMPTY',
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .house-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: 0px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .house-filter-wrap{
            position: relative;
            overflow-x: hidden;
            padding-bottom: 100px;
            &::-webkit-scrollbar {
                display: none;
            }
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .buildin-type{
                padding-bottom: 200px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }

        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .house-filter.open{
        right: 0px;
    }
    // @media screen and (max-width: 1280px) {
    //     .house-filter.open{
    //         right: 24px;
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseFilter.vue